import { render, staticRenderFns } from "./UCPill.vue?vue&type=template&id=0c5bd150&scoped=true&"
import script from "./UCPill.vue?vue&type=script&lang=ts&"
export * from "./UCPill.vue?vue&type=script&lang=ts&"
import style0 from "./UCPill.vue?vue&type=style&index=0&id=0c5bd150&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5bd150",
  null
  
)

export default component.exports